export enum TaskMilestone {
    ToDo = 0,
    InProgress = 1,
    Completed = 2
}
